import * as React from "react";
import "./styles.scss";
import { Checkbox } from "@vebox/etui-core";
import { FindEquipmentContext } from "../../providers/FindEquipmentProvider";
import { DEFAULT_EXCLUSION_FILTERS } from "../../types";
import { AppTranslations } from "../../../../../components/Utils/translations/AppTranslations";
import { FindEquipmentFilter } from "../../components/FindEquipmentFilter";
import { FeaturesFilter } from "../Filters/FeaturesFilter";
import { TelemetryFilter } from "../Filters/TelemetryFilter";
import { SitesFilter } from "../Filters/SitesFilter";

declare var AppTranslations: AppTranslations;

export const FindEquipmentFilters: React.FC = () => {
	const {
		addOrRemoveDefaultFilter,
		selectedDefaultFilter,
		selectedAdditionalFilter,
		setShouldFetchTelemetryFilters,
		setShouldFetchSiteFilters,
	} = React.useContext(FindEquipmentContext);
	const [openDefaultFilters, setOpenDefaultFilters] = React.useState(true);
	const [openAdditionalFilters, setOpenAdditionalFilters] =
		React.useState(false);

	const censusTranslation = AppTranslations.massiveActions.censusCooler;

	React.useEffect(() => {
		setShouldFetchTelemetryFilters(true);
		setShouldFetchSiteFilters(true);
	}, []);

	return (
		<div className={"find-equipment-filter-container"}>
			<FindEquipmentFilter
				name={AppTranslations.genericWords.defaultFilters}
				active={selectedDefaultFilter?.length > 0}
				open={openDefaultFilters}
				openIfActive={true}
				position={"top"}
				onOpen={setOpenDefaultFilters}
			>
				<h2 className={" padding-bottom-10px padding-top-10"}>
					{censusTranslation.excludeEquipment}
				</h2>
				<h2>
					<Checkbox
						name={"select-all"}
						onChange={addOrRemoveDefaultFilter(
							DEFAULT_EXCLUSION_FILTERS.UNAUTHORIZED_MOVEMENT_ALARMS,
						)}
						checked={selectedDefaultFilter?.includes(
							DEFAULT_EXCLUSION_FILTERS.UNAUTHORIZED_MOVEMENT_ALARMS,
						)}
					/>
					<span className={"padding-left-10"}>
						{
							censusTranslation.excludeEquipmentHavingPendedUnauthorizedMovementAlarm
						}
					</span>
				</h2>
				<h2>
					<Checkbox
						name={"select-all"}
						onChange={addOrRemoveDefaultFilter(
							DEFAULT_EXCLUSION_FILTERS.IN_WRITTEN_OFF_OR_MISSING_STATUS,
						)}
						checked={selectedDefaultFilter?.includes(
							DEFAULT_EXCLUSION_FILTERS.IN_WRITTEN_OFF_OR_MISSING_STATUS,
						)}
					/>
					<span className={"padding-left-10"}>
						{censusTranslation.excludeEquipmentWrittenOffMissing}
					</span>
				</h2>
				<h2>
					<Checkbox
						name={"select-all"}
						onChange={addOrRemoveDefaultFilter(
							DEFAULT_EXCLUSION_FILTERS.IN_UNREGISTERED_LOCATION,
						)}
						checked={selectedDefaultFilter?.includes(
							DEFAULT_EXCLUSION_FILTERS.IN_UNREGISTERED_LOCATION,
						)}
					/>
					<span className={"padding-left-10"}>
						{
							censusTranslation.excludeEquipmentCurrentlyPlacedInUnregisteredLocation
						}
					</span>
				</h2>
				<h2>
					<Checkbox
						name={"select-all"}
						onChange={addOrRemoveDefaultFilter(
							DEFAULT_EXCLUSION_FILTERS.IN_WAREHOUSE,
						)}
						checked={selectedDefaultFilter?.includes(
							DEFAULT_EXCLUSION_FILTERS.IN_WAREHOUSE,
						)}
					/>
					<span className={"padding-left-10 "}>
						{censusTranslation.excludeEquipmentInWarehouse}
					</span>
				</h2>
			</FindEquipmentFilter>
			<FindEquipmentFilter
				name={AppTranslations.genericWords.additionalFilters}
				active={selectedAdditionalFilter.length > 0}
				open={openAdditionalFilters}
				openIfActive={true}
				position={"bottom"}
				onOpen={setOpenAdditionalFilters}
				size={openDefaultFilters ? "small" : "large"}
			>
				<FeaturesFilter />
				<TelemetryFilter />
				<SitesFilter />
			</FindEquipmentFilter>
		</div>
	);
};
